 var swiper = new Swiper(".article-slider", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });


$('.video').parent().click(function () {
  if($(this).children(".video").get(0).paused){        $(this).children(".video").get(0).play();   $(this).children(".playpause").fadeOut();
    }else{       $(this).children(".video").get(0).pause();
  $(this).children(".playpause").fadeIn();
    }
});


document.addEventListener('DOMContentLoaded', function() {
    const h2Elements = document.querySelectorAll('.article-description h2');
    const ul = document.querySelector('.article-description ul');
    const tagsMainbox = document.querySelector('.content-tags-mainbox');
    
    // Clear any existing content
    ul.innerHTML = '';

    // Flag to check if there are any <li> elements
    let hasLi = false;

    // Loop through each h2 element
    h2Elements.forEach((h2, index) => {
        const id = `title-${index + 1}`;
        h2.id = id; // Set the ID on the <h2>

        const li = document.createElement('li');
        li.className = 'cc-content-tag';
        li.textContent = h2.textContent.trim();
        li.dataset.targetId = id; // Store the target ID in a data attribute
        
        // Add the li to the ul
        ul.appendChild(li);
        
        // Set flag to true if <li> is added
        hasLi = true;
    });

    // Show or hide the tags mainbox based on presence of <li> elements
    if (hasLi) {
        tagsMainbox.style.display = 'block';
    } else {
        tagsMainbox.style.display = 'none';
    }

    // Add click event listener to each <li>
    ul.addEventListener('click', function(event) {
        const target = event.target;
        if (target.classList.contains('cc-content-tag')) {
            const targetId = target.dataset.targetId;
            const targetElement = document.getElementById(targetId);
            if (targetElement) {
                // Scroll to the target element
                targetElement.scrollIntoView({ behavior: 'smooth' });
            }
        }
    });
});